<div class="donwload-buttons-container">
  <cv-dropdown-button
    *ngIf="isAvailable && pdfDropdownItems"
	class="dropdown-pdf-files"
    [disabled]="loading || !src"
    [label]="loading ? 'Loading PDF ...' : 'PDF'"
    [icon]="'fa-file-pdf'"
    [position]="'down'"
    [buttonClass]="'btn-sm cv-btn-light'"
    [items]="pdfDropdownItems"
    (buttonClick)="onDownloadPDF()"
    (subOptionClick)="onViewPDFversion($event)"
  >
  </cv-dropdown-button>
  <button
    *ngIf="isAvailable && !pdfDropdownItems.length"
    class="btn btn-sm cv-btn-light simple-pdf-button"
    (click)="onDownloadPDF()"
    [disabled]="loading || !src"
  >
    <i class="fa fa-file-pdf"></i>
    <span>PDF</span>
  </button>
</div>
